import type { Board } from "../board";
import type { Direction } from "../direction";
import { BigShockBlast } from "../effects/bigShockBlast";
import { ShockBlast } from "../effects/shockBlast";
import { PhysicalThingWithHp } from "../physicalThingWithHp";
import { Player } from "../player";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { Weapon } from "../weapon";

export class OpGunNuke extends Weapon {
	static key = "OpGunNuke";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	fire(_direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.EXPLOSION));
		board.addEffect(new BigShockBlast(this.owner.xy));
		const things = board
			.getPhysicalThings()
			.filter((t) => t instanceof PhysicalThingWithHp && !(t instanceof Player) && t.active);
		for (const t of things) {
			if (!t.active) continue;
			board.addEffect(new ShockBlast(t.xy));
			(t as PhysicalThingWithHp).kill();
		}
	}

	static deserialize(_data: any, owner: Player): OpGunNuke {
		return new OpGunNuke(owner);
	}
}
